// ── The chat DOCK (chat Figma rebuild, P0 hook; owned by WP3 afterwards) ────────────────────────
//
// Frames 14/15 ("View Task") and 10 (a suggested task opened for editing) dock a panel above the
// box and dim everything else on the page to 50%. This is the one record of that: what is docked
// (`mode`, e.g. 'task') and what it is about (`ref`, e.g. { id }). Content.vue reads `dimmed` for
// its `chat-dimmed` class; components/Home/ChatDock.vue draws the panel.

export const state = {
  mode: null,
  ref: null,
}

export const getters = {
  mode: s => s.mode,
  ref: s => s.ref,
  /** Is the page dimmed behind a docked panel? */
  dimmed: s => !!s.mode,
}

export const actions = {
  /** Dock a panel: `open({ mode: 'task', ref: { id } })`. No mode → nothing docks. */
  open({ commit }, { mode = null, ref = null } = {}) {
    commit('SET', { mode: mode || null, ref: mode ? ref : null })
  },
  close({ commit }) {
    commit('SET', { mode: null, ref: null })
  },
}

export const mutations = {
  SET(s, { mode, ref }) {
    s.mode = mode
    s.ref = ref
  },
}
